<template>
  <div class="login">
    <div class="img-div">
      <div>
        <!-- <img src="../../assets/image/favicon.png" style="width:64px;height:64px;" /> -->
        <p>签到</p>
      </div>
    </div>
    <div class="input-div">
      <el-button type="primary" style="width:100%;" round @click="handleScan">扫一扫</el-button>

    </div>
    <div class="button-div">
      <el-button type="primary" style="width:100%;" round @click="handleLogin">签到</el-button>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import Header from './Header.vue';
// import Menu from './Menu.vue';
// import { Toast } from 'mint-ui';
import wx from 'weixin-js-sdk';

export default {
  name: 'Login',
  data() {
    return {
      token: '',
      restaurants: [],
      schoolId: '',
      schoolName: '',
      account: '',
      password: '',
    };
  },
  components: {},
  created() {
    this.getSignature1();
    wx.error(function (res) {
      alert('出错了：' + res.errMsg); //这个地方的好处就是wx.config配置错误，会弹出窗口哪里错误，然后根据微信文档查询即可。
    });
    wx.ready(function () {
      console.log(1111);
      wx.checkJsApi({
        jsApiList: ['scanQRCode'],
        success: function (res) {},
      });
    });
  },
  computed: {},
  mounted() {
    // 创建script标签，引入外部文件
    // let script = document.createElement('script');
    // script.type = 'text/javascript';
    // script.src = 'https://res.wx.qq.com/open/js/jweixin-1.2.0.js';
    // document.getElementsByTagName('head')[0].appendChild(script);
    // script.onload = function () {
    //   console.log('js资源已加载成功了');
    // };
    // script.onerror = function () {
    //   console.log('js资源加载失败了');
    // };
    // this.getStudentApply()
    // this.getProvince()
    // this.getSchools();
  },
  methods: {
    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return restaurant.fdName.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    async getSignature1() {
      let params = {
        url:location.href.split('#')[0],
        // url: encodeURIComponent(location.href.split('#')[0]),
        // url: location.href.split('#')[0],
      };
      let res = await this.$api.instance.getSignature(params);
      // console.log(res)
      let result = '';
      if (res.code == 0) {
        result = res.data.ticket;
        var t = Date.parse(new Date()) / 1000;
        var sRandom = this.randomString();
        var sa = `jsapi_ticket=${result.ticket}&noncestr=${sRandom}&timestamp=${t}&url=${location.href.split('#')[0]}`;
        var s2 = this.sha1(sa);
        wx.config({
          // debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: 'wx76e9b419207d4c79', // 必填，公众号的唯一标识
          timestamp: '' + t, // 必填，生成签名的时间戳
          nonceStr: sRandom, // 必填，生成签名的随机串
          signature: s2, // 必填，签名
          jsApiList: ['checkJsApi', 'scanQRCode'], // 必填，需要使用的JS接口列表
        });
      }
    },
    handleScan() {
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ['qrCode'], // 可以指定扫二维码还是一维码，默认二者都有
        success: function (res) {
          var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
          window.location.href = result; //因为我这边是扫描后有个链接，然后跳转到该页面
        },
      });
    },
    async getSignature() {
      let params = {
        url: window.origin,
        // url: encodeURIComponent(location.href.split('#')[0]),
        // url: location.href.split('#')[0],
      };
      let res = await this.$api.instance.getSignature(params);
      let result = '';
      if (res.code == 0) {
        result = JSON.parse(res.data.config);
      }
      console.log(result);
      console.log(res.data.ticket);
      wx.config({
        // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        debug: true,
        // 必填，公众号的唯一标识
        appId: result.appId,
        // 必填，生成签名的时间戳
        timestamp: '' + result.timestamp,
        // 必填，生成签名的随机串
        nonceStr: result.nonceStr,
        // 必填，签名，见附录1
        signature: result.signature,
        // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        jsApiList: ['checkJsApi', 'scanQRCode'],
      });
    },
    randomString() {
      var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'; /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
      var maxPos = $chars.length;
      var pwd = '';
      for (let i = 0; i < 16; i++) {
        pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },
    sha1(s) {
      var data = new Uint8Array(this.encodeUTF8(s));
      var i, j, t;
      var l = (((data.length + 8) >>> 6) << 4) + 16,
        s = new Uint8Array(l << 2);
      s.set(new Uint8Array(data.buffer)), (s = new Uint32Array(s.buffer));
      for (t = new DataView(s.buffer), i = 0; i < l; i++) s[i] = t.getUint32(i << 2);
      s[data.length >> 2] |= 0x80 << (24 - (data.length & 3) * 8);
      s[l - 1] = data.length << 3;
      var w = [],
        f = [
          function () {
            return (m[1] & m[2]) | (~m[1] & m[3]);
          },
          function () {
            return m[1] ^ m[2] ^ m[3];
          },
          function () {
            return (m[1] & m[2]) | (m[1] & m[3]) | (m[2] & m[3]);
          },
          function () {
            return m[1] ^ m[2] ^ m[3];
          },
        ],
        rol = function (n, c) {
          return (n << c) | (n >>> (32 - c));
        },
        k = [1518500249, 1859775393, -1894007588, -899497514],
        m = [1732584193, -271733879, null, null, -1009589776];
      (m[2] = ~m[0]), (m[3] = ~m[1]);
      for (i = 0; i < s.length; i += 16) {
        var o = m.slice(0);
        for (j = 0; j < 80; j++)
          (w[j] = j < 16 ? s[i + j] : rol(w[j - 3] ^ w[j - 8] ^ w[j - 14] ^ w[j - 16], 1)),
            (t = (rol(m[0], 5) + f[(j / 20) | 0]() + m[4] + w[j] + k[(j / 20) | 0]) | 0),
            (m[1] = rol(m[1], 30)),
            m.pop(),
            m.unshift(t);
        for (j = 0; j < 5; j++) m[j] = (m[j] + o[j]) | 0;
      }
      t = new DataView(new Uint32Array(m).buffer);
      for (var i = 0; i < 5; i++) m[i] = t.getUint32(i << 2);

      var hex = Array.prototype.map
        .call(new Uint8Array(new Uint32Array(m).buffer), function (e) {
          return (e < 16 ? '0' : '') + e.toString(16);
        })
        .join('');
      return hex;
    },
    encodeUTF8(s) {
      var i,
        r = [],
        c,
        x;
      for (i = 0; i < s.length; i++)
        if ((c = s.charCodeAt(i)) < 0x80) r.push(c);
        else if (c < 0x800) r.push(0xc0 + ((c >> 6) & 0x1f), 0x80 + (c & 0x3f));
        else {
          if ((x = c ^ 0xd800) >> 10 == 0)
            //对四字节UTF-16转换为Unicode
            (c = (x << 10) + (s.charCodeAt(++i) ^ 0xdc00) + 0x10000), r.push(0xf0 + ((c >> 18) & 0x7), 0x80 + ((c >> 12) & 0x3f));
          else r.push(0xe0 + ((c >> 12) & 0xf));
          r.push(0x80 + ((c >> 6) & 0x3f), 0x80 + (c & 0x3f));
        }
      return r;
    },
    handleLogin() {
      // if (!this.schoolObj) {
      //   Toast({
      //     message: '请先选择学校',
      //     position: 'middle',
      //     duration: 5000,
      //   });
      //   return;
      // }
      // if (!this.account) {
      //   Toast({
      //     message: '请先输入账号',
      //     position: 'middle',
      //     duration: 5000,
      //   });
      //   return;
      // }
      // if (!this.password) {
      //   Toast({
      //     message: '请先输入密码',
      //     position: 'middle',
      //     duration: 5000,
      //   });
      //   return;
      // }
      this.loginIn();
    },
    async loginIn() {
      this.$router.push({
        path: '/testTansform',
        query: {
          token: res.data.token,
        },
      });
      // let data = {
      //   j_data: `${this.account};${this.password};1`,
      //   type: 'web',
      //   school_id: this.schoolId,
      // };
      // let res = await this.$api.login.studentLogin(data);
      // console.log(res)
      // if(res.code==20000){
      //   localStorage.clear()
      //   if(res.data.token){
      //     localStorage.setItem('isdd','1')
      //   this.$router.push({
      //     path:'/testTansform',
      //     query:{
      //       token:res.data.token
      //     }
      //   })

      //   }
      // }else{
      //   Toast({
      //     message: res.message,
      //     position: 'middle',
      //     duration: 5000,
      //   });
      // }
    },
    handleSelect(item) {
      // console.log(item);
      this.schoolId = item.id;
      this.schoolName = item.fdName;
      this.schoolObj = item;
    },
    async getSchools() {
      let res = await this.$api.instance.getSchools();
      if (res.code == 0) {
        this.restaurants = res.data;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.login {
  height: 100vh;
  width: 100%;
  .img-div {
    height: 35vh;
    div {
      position: relative;
      top: 50%; /*偏移*/
      margin-top: -50px;
    }
    img {
      width: 64px;
      height: 64px;
    }
    p {
      margin-top: 8px;
      font-size: 14px;
    }
  }
  .input-div {
    // height: 30vh;
    padding: 32px 40px 54px;
    .input-item {
      margin-top: 12px;
    }
    /deep/.el-input__inner {
      border: 0;
      border-bottom: 1px solid #cecdcd;
      border-radius: 0;
      font-size: 12px;
    }
    /deep/.el-input__icon {
      font-size: 18px;
      color: #555;
      line-height: 36px;
    }
    /deep/.el-input--prefix .el-input__inner {
      padding-left: 40px;
    }
  }
  .button-div {
    padding: 0 40px;
    /deep/.el-button--primary {
      background-color: #1690ed;
      border-color: #1690ed;
    }
  }
  // background: #acbfa8;
}
</style>
